import React from "react";
import PropTypes from "prop-types";

function UserImage(props) {
  const { user, defaultUserImage } = props;

  const ImageTag = ({user, defaultUserImage}) => {
    const image = user.image ? user.image : defaultUserImage;
    return (
      <img alt={user.name} className='d-md-block rounded-circle member-image' src={image} />
    );
  };

  return <ImageTag user={user} defaultUserImage={defaultUserImage} />;
}

UserImage.propTypes = {
  user: PropTypes.shape({
    image: PropTypes.string,
  }).isRequired,
  defaultUserImage: PropTypes.string.isRequired
};

export default UserImage;
